import { useEffect, useState } from "react";
import { Row, Col } from "antd";
import UIRecommendationHeaderNew from "./UIRecommendationHeaderNew";
import BestValueProductCard from "./BestValueProductCard";

export default function BestValueProductSection({
  title,
  subtitle,
  iconType,
  backgroundColor,
  fontColor,
  products,
  pros,
  cons
}) {
  if (!products) {
    return null; // skip section if no product
  }
  return (
    <div style={ {padding: '4px 16px' }}>
      {/* Section Header */}
      <UIRecommendationHeaderNew
        iconType={iconType}
        title={title}
        subtitle={subtitle}
        backgroundColor={backgroundColor}
        fontColor={fontColor}
      />

      {/* Product Row */}
      
            <BestValueProductCard
              {...products}
              buttonColor={backgroundColor}
              fontColor={fontColor}
              pros={pros}
              cons={cons}
            />
        
    </div>
  );
}